const vn = {
    all: 'Tất cả',
    mainBranch: 'Chi nhánh chính',
    branchVersion: 'Phiên bản nhánh',
    recordList: 'Danh sách hồ sơ',  
    add: 'Thêm',
    versionNum: 'Số phiên bản',
    updateDesc: 'Hướng dẫn cập nhật',
    file: 'Tài liệu(.apk)',
    downTips: 'Tải xuống, vui lòng để sau.',
    downFailError: 'Tải xuống thất bại, {{error}}',
    addAppRecord: 'Thêm bản ghi phát hành APP',
    plFillInfo: 'Vui lòng điền đầy đủ thông tin!',
    addSuccess:'Thêm thành công',
    delApk: 'Xóa apk',
};

export default vn;